import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const InlineListRow = styled('div')`
    display: flex;
    align-items: flex-start;
    gap: 4px;
`

export const InlineListLabel = styled(Typography)`
    overflow: initial !important;
    flex-shrink: 0;
`

export const StackedListRow = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
`
